/* eslint-disable no-console */
import {
  ACCESS_TOKEN_KEY,
  BACKEND_URL,
  CSRF_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
} from '@/constants';
import axios from 'axios';
import Cookies from 'js-cookie';

const axiosPrivate = axios.create({
  baseURL: `${BACKEND_URL}/api/security`,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosPrivate.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    const lsCsrf = localStorage.getItem(CSRF_TOKEN_KEY);

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    if (lsCsrf) {
      const csrfData = JSON.parse(lsCsrf);
      config.data = {
        csrf_name: csrfData.csrf_name,
        csrf_value: csrfData.csrf_value,
      };
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosPrivate.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error &&
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        let refreshToken = null;
        const lsRefreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
        const cookieRefreshToken = Cookies.get('userRefreshToken');
        if (lsRefreshToken) {
          refreshToken = lsRefreshToken;
        }

        if (!lsRefreshToken && cookieRefreshToken) {
          refreshToken = cookieRefreshToken;
        }

        const lsCsrf = localStorage.getItem(CSRF_TOKEN_KEY);

        if (lsCsrf) {
          const csrfData = JSON.parse(lsCsrf);

          const response = await axios.post(
            `${BACKEND_URL}/api/security/refresh`,
            {
              token: refreshToken,
              csrf_name: csrfData.csrf_name,
              csrf_value: csrfData.csrf_value,
            },
            {
              // withCredentials: true,
              headers: {
                'Content-Type': 'application/json',
              },
            },
          );

          const { access_token, refresh_token } = response.data.data;

          localStorage.setItem(ACCESS_TOKEN_KEY, access_token);
          localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);

          originalRequest.headers.Authorization = `Bearer ${access_token}`;
        }

        return axios(originalRequest);
      } catch (error) {
        return Promise.reject();
      }
    }

    return Promise.reject();
  },
);

export default axiosPrivate;
